import { Menu, Tabs, Typography } from 'antd'
import Button from 'components/Button'
import styled from 'styled-components'
import { COLORS } from 'theme'
export const TitleHeaderSection = styled('div')(() => ({
  background: '#FFFFFF',
  borderBottom: '1px solid #E1E1E1',
  width: '100%',
  padding: 20,
}))
export const InfoHeader = styled('div')(() => ({
  background: '#FAFAFB',
  width: '100%',
  padding: 20,
}))
export const ArrowTitle = styled('div')`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  color: #343e59;
`
export const JobPosition = styled('div')`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: #999fac;
`

export const CompanyTitle = styled('div')`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #343e59;
`

export const TextWithIcon = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? '' : 'center')};

  gap: ${({ gap }) => gap ?? '1rem'};
  width: ${({ width }) => width ?? ''};
  justify-content: ${({ justify }) => justify ?? 'start'};
  flex-direction: ${({ direction }) => direction ?? 'row'};
  flex-wrap: ${props => props.wrap ?? 'nowrap'};
`

export const GroupText = styled.div`
  display: flex;
  justify-content: ${({ justify }) => justify ?? 'start'};
  flex-direction: ${({ direction }) => direction ?? 'row'};
`

export const RoundedCircle = styled.div`
  border-radius: 50%;
  width: 64px;
  height: 64px;
  box-shadow: 0px 2px 6px 0px #7b61ff26;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const IconAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify ?? 'start'};
`

export const ActionButton = styled(Button.Outline)(
  ({
    color,
    staticColor,
    borderNone,
    bgColor,
    decoration,
    fontColor,
    fontSize,
    customHeight,
    disable,
    marginBottom,
  }) => ({
    border: disable
      ? '1px solid #D1D5DB'
      : borderNone
      ? 'none'
      : staticColor
      ? `1px solid ${staticColor}`
      : color === 'secondary'
      ? '1px solid #5DB594'
      : '1px solid #3249D7',
    boxShadow: '0px 1px 2px 0px #1018280D',
    padding: '9px, 20px, 9px, 20px',
    borderRadius: '10px',
    background: disable ? '#F1F1F1' : bgColor ?? '#FFFFFF',
    color: disable
      ? '#B8B8B8'
      : fontColor
      ? fontColor
      : staticColor
      ? staticColor
      : color === 'secondary'
      ? '#5DB594'
      : '#3249D7',
    height: customHeight ?? 37,
    '&:hover': {
      background: bgColor ?? '#FFFFFF',
      border: borderNone
        ? 'none'
        : staticColor
        ? `1px solid ${staticColor}`
        : color === 'secondary'
        ? '1px solid #5DB594'
        : '1px solid #3249D7',
      color: fontColor
        ? fontColor
        : staticColor
        ? staticColor
        : color === 'secondary'
        ? '#5DB594'
        : '#3249D7',
    },
    marginBottom: marginBottom ?? 'unset',
    ' &:focus': {
      background: bgColor ?? '#FFFFFF',
      border: borderNone
        ? 'none'
        : staticColor
        ? `1px solid ${staticColor}`
        : color === 'secondary'
        ? '1px solid #5DB594'
        : '1px solid #3249D7',
      color: fontColor
        ? fontColor
        : staticColor
        ? staticColor
        : color === 'secondary'
        ? '#5DB594'
        : '#3249D7',
    },

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: decoration ?? 'none',
    fontWeight: 600,
    fontSize: fontSize ?? 'unset',
  })
)
export const ActionButtonDanger = styled(Button.Danger)(
  ({ decoration, fontSize }) => ({
    boxShadow: '0px 1px 2px 0px #1018280D',
    padding: '9px, 20px, 9px, 20px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: decoration ?? 'none',
    fontWeight: 600,
    fontSize: fontSize ?? 'unset',
  })
)
export const ActionButtonWithIcon = styled(Button.Default)(
  ({
    color,
    staticColor,
    borderNone,
    bgColor,
    decoration,
    fontColor,
    fontSize,
    customHeight,
    disable,
    icon,
  }) => ({
    border: disable
      ? '1px solid #D1D5DB'
      : borderNone
      ? 'none'
      : staticColor
      ? `1px solid ${staticColor}`
      : color === 'secondary'
      ? '1px solid #5DB594'
      : '1px solid #3249D7',
    boxShadow: '0px 1px 2px 0px #1018280D',
    padding: '9px, 20px, 9px, 20px',
    borderRadius: '10px',
    background: disable ? '#F1F1F1' : bgColor ?? '#FFFFFF',
    color: disable
      ? '#B8B8B8'
      : fontColor
      ? fontColor
      : staticColor
      ? staticColor
      : color === 'secondary'
      ? '#5DB594'
      : '#3249D7',
    height: customHeight ?? 37,
    '&:hover': {
      background: bgColor ?? '#FFFFFF',
      border: borderNone
        ? 'none'
        : staticColor
        ? `1px solid ${staticColor}`
        : color === 'secondary'
        ? '1px solid #5DB594'
        : '1px solid #3249D7',
      color: fontColor
        ? fontColor
        : staticColor
        ? staticColor
        : color === 'secondary'
        ? '#5DB594'
        : '#3249D7',
    },
    ' &:focus': {
      background: bgColor ?? '#FFFFFF',
      border: borderNone
        ? 'none'
        : staticColor
        ? `1px solid ${staticColor}`
        : color === 'secondary'
        ? '1px solid #5DB594'
        : '1px solid #3249D7',
      color: fontColor
        ? fontColor
        : staticColor
        ? staticColor
        : color === 'secondary'
        ? '#5DB594'
        : '#3249D7',
    },

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: decoration ?? 'none',
    fontWeight: 600,
    fontSize: fontSize ?? 'unset',
  })
)

export const PageWrapper = styled.div`
  background: #ffffff;
  padding: 30px;
`

export const SpacingWrapper = styled.div`
  padding-top: ${({ top }) => top ?? '30px'};
  padding-bottom: ${({ bottom }) => bottom ?? '30px'};
`

export const JobTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.5rem;
  color: #343e59;
`

export const JobSubTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 15px;
  color: ${COLORS.GREY_T_10};
`

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: ${props => props.mTop ?? 'unset'};
`
export const ScoreContainer = styled.div`
  display: flex;
  /* align-items: center;
  gap: 10px; */
  flex-direction: row;
`
export const ScoreHeading = styled.div``
export const TextContainerDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: column;
`
export const JobSchedule = styled('div')(({ color, weight, fontSize }) => ({
  color: color ?? COLORS.GREY_T_30,
  fontSize: fontSize ?? 14,
  fontWeight: weight ?? 400,
}))

export const TimeInfo = styled.div`
  padding: 10px;
  background-color: #f3fbfe;
  border-radius: 10px;

  align-content: center;
  border: 1px solid #c5e4fa;
  padding-right: 30px;
`
export const TimeIcon = styled.div`
  display: flex;
  border-radius: 10px;
  background-color: #e2f5fd;
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
  width: 40px;
  height: 40px;
`

export const TimeLabel = styled.div`
  font-weight: ${({ title }) => (title ? 400 : 600)};
  color: ${({ color }) => color ?? COLORS.GREY_T_60};
  font-size: 14px;
`

export const TimeDateDivision = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const OptedOutText = styled(Typography.Text)`
  color: #000000;
  font-weight: 'bold';
`
export const OptOutDiv = styled.div`
  display: flex;
  background-color: #fff2f2;
  width: auto;
  padding: 1rem;
  border-radius: 1rem;
  margin-top: 1rem;
  justify-content: center;
`

export const ULElement = styled.ul`
  padding-left: 25px;
`

export const LIElement = styled.li`
  color: ${({ color }) => (color ? '#000000' : COLORS.GREY_T_50)};
  font-size: ${({ fontSize }) => fontSize ?? '15px'};
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};
  padding-bottom: 2px;
  ::marker {
    color: ${({ color }) => (color ? '#000000' : COLORS.GREY_T_50)};
  }
`

export const QuestionText = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: ${COLORS.GREY_T_60};
`
export const AnswerText = styled.div`
  font-size: 15px;
  font-weight: ${({ fontWeight }) => fontWeight ?? 500};
  color: ${COLORS.GREY_T_30};
`

export const ParaText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`
export const ContainerWrapper = styled.div`
  width: 100%;
  overflow: hidden scroll;
  height: calc(100vh - 85px);
`
export const SectionNavMenu = styled(Menu)`
  font-weight: 600;
  padding-top: 10px;
  .ant-menu-item {
    padding: 0 15px !important;
  }
`
export const MenuItem = styled(Menu.Item)`
  padding: 0 10px;
`
export const HeadingText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${COLORS.BLACK};
`

export const ContainerAlignment = styled.div`
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
`

export const FilterTotalCount = styled.div`
  color: #9a9a9a;
  font-size: 16px;
  font-weight: 499;
  text-align: right;
  padding: 20px 0;
`

export const BorderContainer = styled.div`
  padding: 30px;
  border: 1px solid #e4e4e4;
  border-radius: 20px;
`

export const PlacementContainer = styled.div`
  border: 1px solid #bbbbbb;
  border-radius: 13px;
  height: 80vh;
  scrollbar-width: thin;
  overflow: auto;
  max-height: 100%;
`
export const RowDiv = styled.div`
  display: inline-flex;
  flex-direction: row;
`
export const ButtonDiv = styled.div`
  margin-right: 10px;
`
export const StyledButton = styled.button`
  color: white;
  background-color: rgb(50, 73, 215);
  border-radius: 8px;
  height: 35px;
  border: none;
  font-size: 12px;
  @media (max-width: 768px) {
    font-size: 10px;
  }
  @media (max-width: 480px) {
    font-size: 8px;
  }
`

export const ColDiv = styled.div`
  width: 50%;
`

export const PlacementTitle = styled.div`
  color: #343e59;
  font-size: 16px;
  font-weight: 600;
  padding: 20px;
  border-bottom: 1px solid #e6e7ea;
`

export const PlacementInnerContainer = styled.div`
  padding: 20px;
`

export const SortLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`

export const PlacementBoxContainer = styled.div`
  box-shadow: 0px 4px 4px 0px #00000040;
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 25px;
`
export const PlacedTitle = styled.div`
  color: ${props => props.color ?? '#4b465c'};
  font-size: 14px;
  font-weight: ${props => props.fontWeight ?? 700};
  margin-bottom: 10px;
`

export const CustomTab = styled(Tabs)(() => ({
  '.ant-tabs-nav-list': {
    width: '100%',
  },
  '.ant-tabs-tab': {
    flex: 1,
    justifyContent: 'center',
  },
  '.ant-tabs-tab-active': {
    background: '#F2F4FF',
    border: ' 0px 0px 3px 0px',
  },
  '.ant-tabs-ink-bar': {
    background: '#3249D7',
    height: '3px !important',
  },
  '.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
    color: '#000000',
  },
}))

export const TextSection = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #3249d7;
`
export const TableTextSection = styled.div`
  color: #000000;
  font-size: 10px;
  font-weight: 400;
  text-transform: capitalize;
`

export const CompanyText = styled.div`
  color: #343e59;
  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize;
  white-space: ${props => (props.whiteSpace ? 'normal' : 'nowrap')};
`

export const StatusText = styled.div`
  color: ${props => (props.color ? props?.color : '#0FB680')};
  font-size: 12px;
  font-weight: 400;
`

export const ColorDivider = styled.div`
  border-left: ${props =>
    props.color ? `4px solid ${props?.color}` : '#0FB680'};
  padding-left: 8px;
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
`

export const IconStatusSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TextHeading = styled.div`
  font-size: ${props => props.size ?? '15px'};
  font-weight: ${props => props.weight ?? '700'};
  color: ${props =>
    props.color ? props.color : props.dark ? '#000000' : '#1a2645'};
  margin-top: ${props => props.mTop ?? 'unset'};
  margin-bottom: ${props => props.mBottom ?? 'unset'};
`

export const SkillBox = styled.div`
  background: #ebecee;
  width: Hug (211px) px;
  padding: 3px 8px 3px 8px;
  border-radius: 6px;
  color: #010e30;
  font-size: 14px;
  font-weight: 500;
`
export const SkillBoxDiv = styled.div`
  background: #ebecee;
  width: Hug (211px) px;
  padding: 10px;
  border-radius: 10px;
  color: #010e30;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgb(223 224 227);
`
export const Condition = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #010e30;
  text-align: 'center';
`
